import { find as _find } from 'lodash';

export default class FormValidationService {
  constructor() {
    this.configuration = [
    ];

    this.model = null;

    this.validations = {
      msgs: [],
      errorType: ''
    };

    this.requiredFieldValidatorText = this.requiredFieldValidatorText.bind(this);
    this.requiredFieldValidatorSelect = this.requiredFieldValidatorSelect.bind(this);
    this.requiredFieldValidatorBoolean = this.requiredFieldValidatorBoolean.bind(this);
    this.stringLengthValidator = this.stringLengthValidator.bind(this);
    this.boundFieldValidator = this.boundFieldValidator.bind(this);
    this.urlTypeValidator = this.urlTypeValidator.bind(this);
    this.dateLessThanValidator = this.dateLessThanValidator.bind(this);
    this.pastDateValidator = this.pastDateValidator.bind(this);
    this.floatValidator = this.floatValidator.bind(this);
    this.intValidator = this.intValidator.bind(this);
    this.rangeValidator = this.rangeValidator.bind(this);
  }

  initialize(model) {
    this.configuration = [
    ];

    this.model = model;

    this.fieldCount = 0;
  }

  addField(config) {
    const formValidationService = this;
    let fieldConfig;

    //Check Required Properties
    if (!config || !config.fieldName || !config.displayName) {
      console.log('Invalid Config', config);
      return;
    }

    if (_find(this.configuration, o => o.fieldName === config.fieldName)) {
      config.isDup = true;
    }

    fieldConfig = {
      fieldName: config.fieldName,
      displayName: config.displayName,
      model: config.model,
      type: config.type || 'text',
      required: config.required || false,
      stringLength: {
        min: (config.stringLength && config.stringLength.min) ? config.stringLength.min : null,
        max: (config.stringLength && config.stringLength.max) ? config.stringLength.max : null
      },
      bindTo: config.bindTo || null,
      condition: config.condition || null,
      dateLessThan: config.dateLessThan || null,
      allowPastDate: config.allowPastDate !== undefined  ? config.allowPastDate : null,
      allowedDecimals: config.allowedDecimals || null,
      range: {
        min: (config.range && config.range.min) ? config.range.min : null,
        max: (config.range && config.range.max) ? config.range.max : null
      },
      validators: [],
      isDup: config.isDup || false
    }

    if (fieldConfig.required) {
      if (fieldConfig.type === 'text') {
        fieldConfig.validators.push(this.requiredFieldValidatorText);
      }
      else if (fieldConfig.type === 'boolean') {
        fieldConfig.validators.push(this.requiredFieldValidatorBoolean);
      }
      else {
        fieldConfig.validators.push(this.requiredFieldValidatorSelect);
      }
    }

    if (fieldConfig.stringLength.min && fieldConfig.stringLength.max) {
      fieldConfig.validators.push(this.stringLengthValidator);
    }

    if (fieldConfig.bindTo) {
      fieldConfig.validators.push(this.boundFieldValidator);
    }

    if(fieldConfig.type === 'url') {
      fieldConfig.validators.push(this.urlTypeValidator);
    }

    if (fieldConfig.dateLessThan) {
      fieldConfig.validators.push(this.dateLessThanValidator);
    }

    if (fieldConfig.type === 'datetime' && fieldConfig.allowPastDate === false) {
      fieldConfig.validators.push(this.pastDateValidator);
    }

    if (fieldConfig.type === 'float') {
      fieldConfig.validators.push(this.floatValidator);
    }

    if (fieldConfig.type === 'int') {
      fieldConfig.validators.push(this.intValidator);
    }

    if (fieldConfig.range.min && fieldConfig.range.max) {
      fieldConfig.validators.push(this.rangeValidator);
    }

    formValidationService.configuration.push(fieldConfig);

    if (fieldConfig.isDup) {
      formValidationService.validations[fieldConfig.fieldName + '2'] = true;
    }
    else {
      formValidationService.validations[fieldConfig.fieldName] = true;
    }

    return fieldConfig;
  }

  resetValidations() {
    const formValidationService = this;

    formValidationService.validations = {
      msgs: [],
      errorType: ''
    };

    formValidationService.configuration.map(item => {
      if (item.isDup) {
        formValidationService.validations[item.fieldName + '2'] = true;
      }
      else {
        formValidationService.validations[item.fieldName] = true;
      }
    });
  }

  validateForm() {
    const formValidationService = this;
    let isValid = true;

    formValidationService.resetValidations();

    if (!formValidationService.configuration || !formValidationService.configuration.length) { return isValid; }

    formValidationService.configuration.map(field => {
      field.validators.map(validator => {
        isValid = isValid & validator(field);
      });
    });

    return formValidationService.validations.msgs.length === 0;
  }

  getFieldValue(field) {
    const model = field.model || this.model;

    if(model) {
      return model[field.fieldName];
    }
  }

  requiredFieldValidatorText(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);

    if (field.condition === null){
      if ((!value || value === '') && value !== false) {
        formValidationService.addModelError(field.fieldName, `Please provide a value for ${field.displayName}`, field.isDup);
        return false;
      } else {
        return true;
      }
    }
    else{
      if (eval(field.condition.replace(/{MODEL}/g, 'this.model')) && (!value || value === '' || !value.length)) {
        formValidationService.addModelError(field.fieldName, `Please provide a value for ${field.displayName}`, field.isDup);
        return false;
      } else {
        return true;
      }
    }
  }

  requiredFieldValidatorBoolean(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);

    if (field.condition === null){
      if (typeof(value) === 'undefined' || value === null) {
        formValidationService.addModelError(field.fieldName, `Please provide a value for ${field.displayName}`, field.isDup);
        return false;
      } else {
        return true;
      }
    }
    else{
      if (eval(field.condition.replace(/{MODEL}/g, 'this.model')) && (typeof(value) === 'undefined' || value === null))  {
        formValidationService.addModelError(field.fieldName, `Please provide a value for ${field.displayName}`, field.isDup);
        return false;
      } else {
        return true;
      }
    }
  }

  requiredFieldValidatorSelect(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);

    if (field.condition === null){
      if (!value || value === 0) {
        formValidationService.addModelError(field.fieldName, `Please provide a value for ${field.displayName}`);
        return false;
      } else {
        return true;
      }
    }
    else{
      if (eval(field.condition.replace(/{MODEL}/g, 'this.model')) && (!value || value === 0)) {
        formValidationService.addModelError(field.fieldName, `Please provide a value for ${field.displayName}`);
        return false;
      } else {
        return true;
      }
    }
  }

  stringLengthValidator(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);
    const stringLength = field.stringLength;

    if (!value) { return false; }

    if (field.condition === null){
      if(value && (value.length < stringLength.min || value.length > stringLength.max)) {
        formValidationService.addModelError(field.fieldName, `${field.displayName} should be between ${stringLength.min} and ${stringLength.max} characters`, field.isDup);
        return false;
      } else {
        return true;
      }
    }
    else {
      if(eval(field.condition.replace(/{MODEL}/g, 'this.model')) && value && (value.length < stringLength.min || value.length > stringLength.max)) {
        formValidationService.addModelError(field.fieldName, `${field.displayName} should be between ${stringLength.min} and ${stringLength.max} characters`, field.isDup);
        return false;
      } else {
        return true;
      }
    }
  }

  boundFieldValidator(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);
    const boundValue = formValidationService.getFieldValue(field.bindTo);

    if(value !== boundValue) {
      formValidationService.addModelError([field.fieldName, field.bindTo.fieldName], `${field.displayName} and ${field.bindTo.displayName} do not match`);
      return false;
    } else {
      return true;
    }
  }

  urlTypeValidator(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);
    const pattern = new RegExp(/[a-z0-9-\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?$/,'i'); // fragment locator

    if (value) {
      if (!pattern.test(value)) {
        formValidationService.addModelError(field.fieldName, `Please provide a valid URL for the ${field.displayName}`);
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  dateLessThanValidator(field) {
    const formValidationService = this;
    const dtStart = formValidationService.getFieldValue(field.dateLessThan);
    const dtEnd = formValidationService.getFieldValue(field);

    if(dtEnd <= dtStart) {
      formValidationService.addModelError([field.fieldName, field.dateLessThan.fieldName], `${field.dateLessThan.displayName} cannot be greater than ${field.displayName}`);
      return false;
    } else {
      return true;
    }
  }

  pastDateValidator(field) {
    const formValidationService = this;
    const dt = formValidationService.getFieldValue(field);

    if (!dt) { return false; }

    if(dt < new Date().withoutTime()) {
      formValidationService.addModelError([field.fieldName], `${field.displayName} cannot be in the past`);
      return false;
    } else {
      return true;
    }
  }

  floatValidator(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);
    let pattern = '';

    if (field.allowedDecimals) {
      pattern = new RegExp(`^-?\\d*(\\.\\d{0,${field.allowedDecimals}})?$`);
    }
    else {
      pattern = new RegExp(/^-?\d*(\.\d+)?$/);
    }

    if (!value) {return true;}

    if (!pattern.exec(value)) {
      if (field.allowedDecimals) {
        formValidationService.addModelError([field.fieldName], `${field.displayName} must be a valid floating point number with a maximum of ${field.allowedDecimals} decimals`);
      }
      else{
        formValidationService.addModelError([field.fieldName], `${field.displayName} must be a valid floating point number`);
      }

      return false;
    }
    else {
      return true;
    }
  }

  intValidator(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);
    const pattern = new RegExp(/^-?\d*?$/);

    if (!value) {return true;}

    if (!pattern.exec(value)) {
      formValidationService.addModelError([field.fieldName], `${field.displayName} must be a valid number`);

      return false;
    }
    else {
      return true;
    }
  }

  rangeValidator(field) {
    const formValidationService = this;
    const value = formValidationService.getFieldValue(field);
    const range = field.range;

    if (!value) { return true; }

    if(value && (value < range.min || value > range.max)) {
      formValidationService.addModelError(field.fieldName, `${field.displayName} should be between ${range.min} and ${range.max}`);
      return false;
    } else {
      return true;
    }
  }

  addModelError(fields, errorMsg, isDup) {
    this.addError(fields, 'Model', errorMsg, isDup);
  }

  addSystemError(fields, errorMsg, isDup) {
    this.addError(fields, 'System', errorMsg, isDup);
  }

  addError(fields, errorType, errorMsg, isDup)
  {
    const formValidationService = this;

    formValidationService.validations.errorType = errorType;

    if (Array.isArray(fields)) {
      fields.map(field => {
        if (isDup) { //Dirty Hack
          formValidationService.validations[field + '2'] = false;
        }
        else {
          formValidationService.validations[field] = false;
        }
      });
    } else {
      if (isDup) { //Dirty Hack
        formValidationService.validations[fields + '2'] = false;
      }
      else {
        formValidationService.validations[fields] = false;
      }
    }

    formValidationService.validations.msgs.push(errorMsg);
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/FormValidationService.js